import React, { FunctionComponent } from "react";
import styles from "./Spot.module.scss";
import SpotProps from "./SpotProps.interface";

import getSpecialLink from "./helpers/getSpecialLink";
import Link from "components/Link/Link";

import { useDispatch } from "react-redux";
import Button from "components/Button/Button";
import combineClasses from "helpers/combine-classes";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import getImageCrop from "app/media/helpers/getImageCrop";
import getProcessedRichtext from "blocks/helpers/getProcessedRichtext";
import handleOpenModal from "blocks/helpers/handleOpenModal";
import IconViewer from "components/IconViewer/IconViewer";
import ImageViewer from "components/ImageViewer/ImageViewer";

const Spot: FunctionComponent<SpotProps> = (props) => {
    const dispatch = useDispatch();

    const processedBodyText = getProcessedRichtext(props.content.bodyText);
    const imageCrop = getImageCrop(props.content.image?.umbracoFile.crops, undefined, "Fullscreen (4:3)");
    const imageAspectRatio = getImageAspectRatio(imageCrop, props.content.image?.umbracoWidth, props.content.image?.umbracoHeight);

    const iconName = props.content.icon ? props.content.icon.toLowerCase() : undefined;
    const hasIconClass = props.content.icon && !props.content.image ? styles.has_icon : styles.has_image;

    const link = getSpecialLink(props.content.buttons);
    const hasLinkClass = link ? styles.has_link : undefined;

    return (
        <div className={styles.wrapper}>
            <div className={combineClasses([styles.inner, hasIconClass, hasLinkClass])}>
                <Link className={styles.link} link={link}>
                    {/* Icon */}
                    {props.content.icon && !props.content.image ? (
                        <div className={styles.icon_wrapper}>
                            <IconViewer className={styles.icon} name={iconName} />
                        </div>
                    ) : null}

                    {/* Media */}
                    {props.content.image ? (
                        <div className={styles.media}>
                            <ImageViewer src={props.content.image.umbracoFile.src} crop={imageCrop} focalPoint={props.content.image.umbracoFile.focalPoint} alt={props.content.imageAlternative} aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} />
                        </div>
                    ) : null}
                </Link>

                {/* Content */}
                <div className={styles.content}>
                    <Link className={styles.link} link={link}>
                        {props.content.heading ? (
                            <h3 className={styles.headline}>{props.content.heading}</h3>
                        ) : null}

                        {processedBodyText ? (
                            <div className={styles.text} dangerouslySetInnerHTML={processedBodyText}></div>
                        ) : null}
                    </Link>

                    <div className={styles.buttons}>
                        {props.content.buttons && props.content.buttons.length > 0 ? props.content.buttons.map((button) => {
                            return button.content._contentType !== "modalButton" && button.content._contentType !== "anchorButton" ? (
                                <Button key={button.contentUdi} className={styles.button} modal={button.content.modal} onClick={() => { button.content.modal ? handleOpenModal(button.content.modal, button.content.stickyLink, dispatch) : undefined; }} to={button.content.link} parameters={button.content.parameters} anchor={button.content.anchor} settings={button.settings}>
                                    {button.content.label}
                                </Button>
                            ) : null;
                        }) : null}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Spot;